import { render, staticRenderFns } from "./MemoTimelineSection.vue?vue&type=template&id=80baae10&"
import script from "./MemoTimelineSection.vue?vue&type=script&lang=ts&"
export * from "./MemoTimelineSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports